import React, { Component } from 'react';
import Campaigns from './Campaigns';


class Flow extends Component {

   
  
    render() {

        return (<Campaigns type="AUTOMATIC"/>);
      
    }
}

export default Flow;
